<template>
  <v-container>
    <page-heading>{{ pageTitle }}</page-heading>

    <ajax-table
        ref="guestsTable"
        :resource="resourceUrl"
        :headers="[
          {text: 'guest.name', value: 'name'},
          {text: 'guest.street', value: 'streetAddress'},
          {text: 'guest.zipcode', value: 'zipcode'},
          {text: 'guest.city', value: 'city'},
          {text: 'guest.country', value: 'country'},
          {text: 'guest.contact', value: 'contact'},
        ]"
        :page-options="{itemsPerPage: 20}"
        :items-per-page-options="[10, 20, 50]"
        filterable
        :filter="filter"
        exportable
    >

      <template v-slot:item.name="{ item }">
        <guest-name :value="item" :open-in-new-tab="false" />
      </template>

      <template v-slot:item.streetAddress="{item}">
        {{ item.street }} {{ item.houseNumber }}
      </template>

      <template v-slot:item.contact="{item}">
        <div class="subtext"><a :href="'mailto:' + item.email">{{ item.email }}</a></div>
        <div class="subtext"><a :href="'tel:' + item.phone">{{ item.phone }}</a></div>
      </template>

      <template v-slot:filters>
        <search v-model="filterData.search" />
      </template>
    </ajax-table>

  </v-container>
</template>

<script>
import {GuestApi} from "@/api/guest-api";
import {LocaleUtils} from '../utils/locale-utils';
import Search from '@/components/Search';
import AjaxTable from "@/components/AjaxTable";
import PageHeading from "@/components/PageHeading";
import {MainUtils} from "@/utils/main-utils";
import {RouterUtils} from "@/utils/router-utils";
import {FilterUtils} from '@/utils/filter-utils';
import GuestName from "@/components/GuestName";

export default {
  name: "GuestsPage",
  mixins: [
    MainUtils,
    RouterUtils,
    LocaleUtils,
    FilterUtils
  ],
  components: {
    AjaxTable,
    PageHeading,
    Search,
    GuestName
  },
  data: () => ({
    filterData: {
      search: null
    }
  }),
  computed: {
    resourceUrl () {
      return GuestApi.apiUri;
    },
    filter () {
      let filters =  [];
      if(this.filterData.search) {
        filters.push(this.buildSearchFilter(this.filterData.search, ['firstName', 'lastName', 'email']));
      }
      return filters;
    },
    pageTitle () {
      return this.trans('guest.guests');
    }
  },
  activated () {
    this.$refs.guestsTable.loadData();
  }
}
</script>

<style scoped>

</style>
